// extracted by mini-css-extract-plugin
export default {"authContainer":"auth_authContainer__MZcxI","leftImage":"auth_leftImage__Hwd4X","loginForm":"auth_loginForm__H+bqh"};